const baseSize = 37.5; // 与 postcss rootValue 保持一致

function setRem() {
  const scale = document.documentElement.clientWidth / 375; // 以375为标准
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + "px"; // 限制最大2倍
}

// 初始化
setRem();

// 改变窗口大小重新设置
window.onresize = function () {
  setRem();
};
